/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var $ = require('jquery');
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');
require('flickity-as-nav-for');
import Mmenu from 'mmenu-js';

Flickity.setJQuery($);
jQueryBridget('flickity', Flickity, $);

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // Mobile navigation
        var mobilemenu = document.querySelector('#mmenu-nav');
        var mmenu = new Mmenu(mobilemenu, {
          offCanvas: {
            position: 'top',
          },
          navbar: {
            title: ' ',
          },
          navbars: [
            {
              position: 'top',
              content: [
                '<div class="logo"><a href="/"><img src="/wp-content/themes/worldcentric/dist/images/logo.svg" alt="World Centric" width="124" height="48" /></a></div>',
                '<div class="closebtn"><button class="closenav"><span class="sr">Close Navigation</span><div class="close"><span>x</span></div></button></div>',
              ],
            },
            {
              position: 'bottom',
              content: [
                '<form action="/" role="search" method="get" class="mmenu-search-form"><label for="mmenu-search" class="sr">Search</label><input type="text" name="s" id="mmenu-search" placeholder="Search..." /><button type="submit"><span class="sr">Search</span><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg></button></form>',
              ],
            },
          ],
        });
        var mmenuAPI = mmenu.API;
        $('.opennav').on('click', function () {
          mmenuAPI.open();
        });
        $(document).on('click', '.closenav', function (e) {
          e.preventDefault();
          mmenuAPI.close();
        });
        $('.opensearch').on('click', function () {
          $('.navsearch').slideToggle();
        });
        $('.closesearch').on('click', function () {
          $('.navsearch').slideToggle();
        });

        // Desktop navigation
        $('.nav button').on('click', function () {
          if ($(this).hasClass('active')) {
            $('.nav button').removeClass('active');
            $('.navtabs').slideUp();
          } else {
            $('.nav button').removeClass('active');

            $(this).addClass('active');
            var tab = $(this).data('tab');
            $('.navtabs').slideDown();
            $('.navtabs > div').hide();
            $('#navtab-' + tab).fadeIn();
          }
        });
        $(window).on('resize', function () {
          $('.nav button').removeClass('active');
          $('.navtabs').slideUp();
        });
        var currentDesktopNavItem = $('.navtabs .current-menu-item');
        if (currentDesktopNavItem.length) {
          var navId = currentDesktopNavItem
            .closest('[id^="navtab-"]')
            .data('navid');
          $('button[data-tab="' + navId + '"]').addClass('current-menu');
        }

        // Sub-Nav Mobile
        // if (window.innerWidth <= 1100) {
        //   $('.block-sub-nav').each(function () {
        //     var $ul = $(this).find('ul');
        //     var $select = $('<select class="mobile-sub-nav" />');
        //     $select.append(
        //       $('<option>', {
        //         value: '',
        //         text: 'Select a page...',
        //         disabled: true,
        //       })
        //     );
        //     $ul.find('a').each(function () {
        //       $select.append(
        //         $('<option>', {
        //           value: $(this).attr('href'),
        //           text: $(this).text(),
        //           selected: $(this).parent().hasClass('current-menu-item'),
        //         })
        //       );
        //     });
        //     $select.on('change', function () {
        //       window.location.href = this.value;
        //     });
        //     $ul.hide().after($select);
        //   });
        // }

        // Slider Grids
        $('.slider-grid').each(function () {
          var $this = $(this);
          if ($this.children().length > 1) {
            $this
              .flickity({
                wrapAround: false,
                prevNextButtons: true,
                pageDots: false,
                cellAlign: 'center',
                lazyLoad: 1,
              })
              .data('flickity');
          }
          $this.find('.flickity-prev-next-button.previous').text('← Newer');
          $this.find('.flickity-prev-next-button.next').text('Older →');
        });
        $('.load-more-slider-grid').on('click', function () {
          $(this)
            .parent()
            .siblings('.slider-grids')
            .children('.slider-grid')
            .show();
          $('.slider-grid').each(function () {
            $(this).flickity('resize');
          });
          $(this).hide();
        });

        // Link Slider
        $('.link-slider').each(function () {
          var $this = $(this);
          if ($this.children().length > 1) {
            $this
              .flickity({
                wrapAround: false,
                prevNextButtons: true,
                pageDots: false,
                cellAlign: 'left',
              })
              .data('flickity');
          }
        });
        // Full width Slideshow
        $('.full-slides').each(function () {
          var $this = $(this);
          // var flickityInstance = $this
          $this.flickity({
            wrapAround: true,
            prevNextButtons: true,
            pageDots: false,
            cellAlign: 'center',
            lazyLoad: 1,
            autoPlay: 8000,
            pauseAutoPlayOnHover: true,
          });
          //   .data('flickity');
          // $('.custom-slider-prev').on('click', function () {
          //   flickityInstance.previous();
          // });
          // $('.custom-slider-next').on('click', function () {
          //   flickityInstance.next();
          // });
        });

        // Dynamic synchronized sliders (image + content)
        $('.dynamic-slides').each(function () {
          var $container = $(this);
          var $contentSlider = $container.find('.content-slider');
          var $imageSlider = $container.find('.image-slider');
          var $navButtons = $container.find('.custom-slider-nav');

          $imageSlider.flickity({
            wrapAround: true,
            prevNextButtons: true,
            pageDots: false,
            cellAlign: 'center',
            lazyLoad: 1,
            draggable: false,
          });

          $contentSlider.flickity({
            asNavFor: $imageSlider[0],
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'center',
            lazyLoad: 1,
            draggable: false,
          });

          // Scoped custom nav buttons control the content slider
          $navButtons.find('.custom-slider-prev').on('click', function () {
            $contentSlider.flickity('previous');
          });
          $navButtons.find('.custom-slider-next').on('click', function () {
            $contentSlider.flickity('next');
          });
        });

        // Dynamic synchronized sliders (image + content) with textarea
        $('.dynamic-with-textarea-slides').each(function () {
          var $container = $(this);
          var $contentSlider = $container.find('.alt-content-slider');
          var $imageSlider = $container.find('.alt-image-slider');
          var $navButtons = $container.find('.alt-custom-slider-nav');

          $imageSlider.flickity({
            wrapAround: true,
            prevNextButtons: true,
            pageDots: false,
            cellAlign: 'center',
            lazyLoad: 1,
            draggable: false,
          });

          $contentSlider.flickity({
            asNavFor: $imageSlider[0],
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            cellAlign: 'center',
            lazyLoad: 1,
            draggable: false,
          });

          // Scoped custom nav buttons control the content slider
          $navButtons.find('.custom-slider-prev').on('click', function () {
            $contentSlider.flickity('previous');
          });
          $navButtons.find('.custom-slider-next').on('click', function () {
            $contentSlider.flickity('next');
          });
        });

        // Thin semi-visible Slideshow
        var semislider = $('.thin-slides');
        var flickityInstance = semislider
          .flickity({
            wrapAround: true,
            prevNextButtons: true,
            pageDots: false,
            cellAlign: 'center',
            lazyLoad: 1,
            autoPlay: 8000,
            pauseAutoPlayOnHover: true,
          })
          .data('flickity');
        function updateAdjacentSlides(index) {
          if (!flickityInstance) return;
          var $cells = semislider.find('.carousel-cell');
          $cells.removeClass('is-prev is-next');
          var totalSlides = flickityInstance.slides.length;
          if (totalSlides <= 1) return;
          var prevIndex = (index - 1 + totalSlides) % totalSlides;
          var nextIndex = (index + 1) % totalSlides;
          $cells.eq(prevIndex).addClass('is-prev');
          $cells.eq(nextIndex).addClass('is-next');
        }
        semislider.on('change.flickity', function (event, index) {
          updateAdjacentSlides(index);
        });
        $('.custom-slider-prev').on('click', function () {
          flickityInstance.previous();
        });
        $('.custom-slider-next').on('click', function () {
          flickityInstance.next();
        });

        // Product Slideshow - 3 per view with center active
        $('.product-slides').each(function () {
          var $this = $(this);
          // var flickityInstance = $this
          $this.flickity({
            wrapAround: true,
            prevNextButtons: true,
            pageDots: false,
            cellAlign: 'center',
            lazyLoad: 1,
            groupCells: false,
            contain: false,
            autoPlay: 3000,
            pauseAutoPlayOnHover: true,
            initialIndex: 1,
            freeScroll: false,
            percentPosition: false,
          });
          //   .data('flickity');
          // $('.custom-slider-prev').on('click', function () {
          //   flickityInstance.previous();
          // });
          // $('.custom-slider-next').on('click', function () {
          //   flickityInstance.next();
          // });
        });

        // Load More Columns
        $('.loadmorecols').on('click', function () {
          $(this).parent().parent().children('.col').fadeIn();
          $(this).hide();
        });

        // State Laws Accordion functionality
        $(document).on(
          'click',
          '.block-state-laws .accordion-trigger',
          function (e) {
            e.preventDefault();
            var $trigger = $(this);
            var $accordionContainer = $trigger.closest('.block-state-laws');
            var $contentContainer = $('#' + $trigger.attr('aria-controls'));
            var $allToggles = $accordionContainer.find('.accordion-trigger');
            var $allTabs = $accordionContainer.find('.state-tab');
            var isCurrentlyExpanded = $trigger.attr('aria-expanded') === 'true';

            // Close all accordion items first and reset their text
            $allToggles.attr('aria-expanded', 'false');
            $allTabs.removeClass('expanded').addClass('collapsed');
            $allToggles.find('.more-text').text('More +');

            // If this wasn't expanded, open it
            if (!isCurrentlyExpanded) {
              $trigger.attr('aria-expanded', 'true');
              $contentContainer.removeClass('collapsed').addClass('expanded');
              $trigger.find('.more-text').text('Less -');
            } else {
              $trigger.attr('aria-expanded', 'false');
              $contentContainer.removeClass('expanded').addClass('collapsed');
              $trigger.find('.more-text').text('More +');
            }
          }
        );

        // Map state click functionality - opens corresponding accordion
        $(document).on('click', '.block-state-laws g#states a', function (e) {
          e.preventDefault();
          var $mapState = $(this);
          var stateTitle = $mapState.attr('title');
          var $accordionContainer = $mapState.closest('.block-state-laws');

          if (stateTitle) {
            // Find the corresponding accordion trigger and content
            var $accordionTrigger = $accordionContainer.find(
              '.accordion-trigger[aria-controls*="' +
                stateTitle.toLowerCase().replace(/\s+/g, '') +
                '"]'
            );
            var $contentContainer = $accordionContainer.find(
              '.state-tab[id*="' +
                stateTitle.toLowerCase().replace(/\s+/g, '') +
                '"]'
            );

            if ($accordionTrigger.length && $contentContainer.length) {
              // Close all accordion items first
              var $allToggles = $accordionContainer.find('.accordion-trigger');
              var $allTabs = $accordionContainer.find('.state-tab');

              $allToggles.attr('aria-expanded', 'false');
              $allTabs.removeClass('expanded').addClass('collapsed');
              $allToggles.find('.more-text').text('More +');

              // Open the corresponding accordion
              $accordionTrigger.attr('aria-expanded', 'true');
              $contentContainer.removeClass('collapsed').addClass('expanded');
              $accordionTrigger.find('.more-text').text('Less -');

              // Scroll to the accordion content with 100px offset
              const currentScrollPosition =
                window.pageYOffset || document.documentElement.scrollTop;
              const targetElement = $contentContainer[0];
              const targetPosition = targetElement.offsetTop - 100;

              window.scrollTo({
                top: targetPosition,
                behavior: 'smooth',
              });
            }
          }
        });

        // State Law Search
        function searchStates() {
          var search = $('#search-states')
            .val()
            .toLowerCase()
            .replace(/[\s\W_]+/g, '');
          $('.state-tab-wrap').each(function () {
            var state = $(this)
              .find('.state-title button')
              .data('state')
              .toLowerCase();
            if (
              state.includes(search) ||
              (search == 'dc' && state == 'districtofcolumbia') ||
              (search == 'ny' && state == 'newyork')
            ) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        }
        $('#search-states').on('change keyup', searchStates);
        $('#state-search').on('submit', function (e) {
          e.preventDefault();
          searchStates();
        });

        // Event Calendar
        $('.event-filter button').on('click', function () {
          let category = $(this).data('cat');
          $('.event-filter button').removeClass('active');
          $(this).addClass('active');
          $.ajax({
            type: 'POST',
            url: ajax_object.ajax_url,
            data: {
              action: 'filter_events',
              category: category,
            },
            success: function (response) {
              $('.events-block').html(response);
            },
          });
        });

        // Contact Form Tabs
        $('.contact-tabs button').on('click', function () {
          let formtab = $(this).data('id');
          $('.contact-tabs button').removeClass('active');
          $('.formtab').hide();
          $(this).addClass('active');
          $('#' + formtab).show();
        });
        if ($('.contact-tabs').length && window.location.hash) {
          let hash = window.location.hash.substring(1);
          if (hash === 'general' || hash === 'support') {
            console.log(hash);
            $('.contact-tabs button').removeClass('active');
            $('.formtab').hide();
            $('.contact-tabs button[data-id="form-' + hash + '"]').addClass(
              'active'
            );
            $('#form-' + hash).show();
          }
        }

        // Accordion Columns functionality
        $(document).on(
          'click',
          '.block-accordion-columns .accordion-trigger',
          function (e) {
            e.preventDefault();
            var $trigger = $(this);
            var $accordionContainer = $trigger.closest(
              '.block-accordion-columns'
            );
            var $contentContainer = $('#' + $trigger.attr('aria-controls'));
            var $allToggles = $accordionContainer.find('.accordion-trigger');
            var $allCollapses = $accordionContainer.find('.more');
            var isCurrentlyExpanded = $trigger.attr('aria-expanded') === 'true';

            // Close all accordion items first
            $allToggles.attr('aria-expanded', 'false');
            $allCollapses.removeClass('expanded').addClass('collapsed');

            // If this wasn't expanded, open it
            if (!isCurrentlyExpanded) {
              $trigger.attr('aria-expanded', 'true');
              $contentContainer.removeClass('collapsed').addClass('expanded');
              $trigger.find('.more-text').text('Less -');
            } else {
              $trigger.attr('aria-expanded', 'false');
              $contentContainer.removeClass('expanded').addClass('collapsed');
              $trigger.find('.more-text').text('More +');
            }
          }
        );

        // ACF Accordion functionality
        $(document).on(
          'click',
          '.block-accordion .accordion-trigger',
          function (e) {
            e.preventDefault();
            var $trigger = $(this);
            var $accordionContainer = $trigger.closest('.block-accordion');
            var $contentContainer = $('#' + $trigger.attr('aria-controls'));
            var $allToggles = $accordionContainer.find('.accordion-trigger');
            var $allTabs = $accordionContainer.find('.accordion-tab');
            var isCurrentlyExpanded = $trigger.attr('aria-expanded') === 'true';

            // Close all accordion items first and reset their text
            $allToggles.attr('aria-expanded', 'false');
            $allTabs.removeClass('expanded').addClass('collapsed');
            $allToggles.find('.more-text').text('More +');

            // If this wasn't expanded, open it
            if (!isCurrentlyExpanded) {
              $trigger.attr('aria-expanded', 'true');
              $contentContainer.removeClass('collapsed').addClass('expanded');
              $trigger.find('.more-text').text('Less -');
            } else {
              $trigger.attr('aria-expanded', 'false');
              $contentContainer.removeClass('expanded').addClass('collapsed');
              $trigger.find('.more-text').text('More +');
            }
          }
        );

        // FAQ Accordion functionality
        $(document).on('click', '.faq-page .accordion-trigger', function (e) {
          e.preventDefault();
          var $trigger = $(this);
          var $accordionContainer = $trigger.closest('.faq-page');
          var $contentContainer = $('#' + $trigger.attr('aria-controls'));
          var $allToggles = $accordionContainer.find('.accordion-trigger');
          var $allTabs = $accordionContainer.find('.accordion-tab');
          var isCurrentlyExpanded = $trigger.attr('aria-expanded') === 'true';

          // Close all accordion items first and reset their text
          $allToggles.attr('aria-expanded', 'false');
          $allTabs.removeClass('expanded').addClass('collapsed');
          $allToggles.find('.more-text').text('More +');

          // If this wasn't expanded, open it
          if (!isCurrentlyExpanded) {
            $trigger.attr('aria-expanded', 'true');
            $contentContainer.removeClass('collapsed').addClass('expanded');
            $trigger.find('.more-text').text('Less -');
          } else {
            $trigger.attr('aria-expanded', 'false');
            $contentContainer.removeClass('expanded').addClass('collapsed');
            $trigger.find('.more-text').text('More +');
          }
        });

        // Before/After Style Hero
        if ($('#before-after-slider').length) {
          function updateMobileBackgrounds() {
            $('[data-mobilebg]').each(function () {
              if (window.matchMedia('(max-width: 1100px)').matches) {
                var mobilebg = $(this).data('mobilebg');
                $(this).css('background-image', 'url(' + mobilebg + ')');
              } else {
                var desktopbg = $(this).data('desktopbg');
                $(this).css('background-image', 'url(' + desktopbg + ')');
              }
            });
          }
          $(document).ready(updateMobileBackgrounds);
          $(window).on('resize', updateMobileBackgrounds);

          const baslider = document.getElementById('before-after-slider');
          const before = document.getElementById('before-image');
          const resizer = document.getElementById('resizer');
          let active = false;
          document.addEventListener('DOMContentLoaded', function () {
            let width = baslider.offsetWidth;
            console.log(width);
            before.style.width = width + 'px';
          });
          window.addEventListener('resize', function () {
            let width = baslider.offsetWidth;
            console.log(width);
            before.style.width = width + 'px';
          });
          resizer.addEventListener('mousedown', function () {
            active = true;
            resizer.classList.add('resize');
          });
          document.body.addEventListener('mouseup', function () {
            active = false;
            resizer.classList.remove('resize');
          });
          document.body.addEventListener('mouseleave', function () {
            active = false;
            resizer.classList.remove('resize');
          });
          document.body.addEventListener('mousemove', function (e) {
            if (!active) return;
            let x = e.pageX;
            x -= baslider.getBoundingClientRect().left;
            slideIt(x);
            pauseEvent(e);
          });
          resizer.addEventListener('touchstart', function () {
            active = true;
            resizer.classList.add('resize');
          });
          document.body.addEventListener('touchend', function () {
            active = false;
            resizer.classList.remove('resize');
          });
          document.body.addEventListener('touchcancel', function () {
            active = false;
            resizer.classList.remove('resize');
          });
          document.body.addEventListener('touchmove', function (e) {
            if (!active) return;
            let x;
            let i;
            for (i = 0; i < e.changedTouches.length; i++) {
              x = e.changedTouches[i].pageX;
            }
            x -= baslider.getBoundingClientRect().left;
            slideIt(x);
            pauseEvent(e);
          });
          function slideIt(x) {
            let transform = Math.max(0, Math.min(x, baslider.offsetWidth));
            before.style.width = transform + 'px';
            resizer.style.left = transform - 0 + 'px';
          }
          function pauseEvent(e) {
            if (e.stopPropagation) e.stopPropagation();
            if (e.preventDefault) e.preventDefault();
            e.cancelBubble = true;
            e.returnValue = false;
            return false;
          }
        }

        // Auto add target=_blank to all external links
        function isExternalLink(link) {
          return (
            link.hostname !== window.location.hostname &&
            link.hostname !== 'store.worldcentric.com' &&
            link.protocol !== 'mailto:' &&
            link.protocol !== 'tel:' &&
            link.hash === ''
          );
        }
        const links = document.querySelectorAll('a');
        links.forEach(link => {
          if (isExternalLink(link)) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener');
            //link.innerHTML += '<span class="sr"> (opens in new window)</span>';
          }
        });

        // Close Notice Bar
        // $('.closenotice').on('click', function () {
        //   $.ajax({
        //     url: '/wp-admin/admin-ajax.php',
        //     type: 'POST',
        //     data: {
        //       action: 'set_noticebar_closed',
        //     },
        //   });
        //   $('.noticebar').slideUp();
        // });

        // Add arrow SVG to arrow-link elements
        $('.arrow-link').each(function () {
          const arrowSvg = `<svg class="arrow-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="currentColor">
    <path class="notch" d="M81.16,54.63,58.82,77a4.16,4.16,0,1,0,5.89,5.89L94.16,53.42h0a4.18,4.18,0,0,0,0-5.9h0L64.71,18.06A4.17,4.17,0,1,0,58.82,24L81.16,46.3c2,2.05,3.34,3,3.34,4.25S81.16,54.63,81.16,54.63Z"></path>
    <path class="tail" d="M86.66,54.64H9A4.17,4.17,0,1,1,9,46.3H86.62S86.83,54.47,86.66,54.64Z"></path>
  </svg>`;
          $(this).append(arrowSvg);
        });

        // Parallax effect for .spoon-bg
        const $spoonBg = $('.spoon-bg');

        if ($spoonBg.length) {
          const $spoonSection = $spoonBg.closest('.block-spoons');

          let ticking = false;

          function updateParallax() {
            const windowHeight = $(window).height();
            const scrollTop = $(window).scrollTop();
            const sectionTop = $spoonSection.offset().top;
            const sectionHeight = $spoonSection.outerHeight();
            const sectionBottom = sectionTop + sectionHeight;

            // Calculate how much of the section is visible
            const viewportTop = scrollTop;
            const viewportBottom = scrollTop + windowHeight;

            // Check if section is in viewport
            const isInViewport =
              sectionBottom >= viewportTop && sectionTop <= viewportBottom;

            if (isInViewport) {
              // Calculate progress through the section (0 to 1) - faster transition
              const sectionProgress = Math.max(
                0,
                Math.min(
                  1,
                  (viewportBottom - sectionTop) /
                    (windowHeight + sectionHeight * 0.4)
                )
              );

              // Apply parallax based on section progress
              const parallaxDistance = 1800; // Max pixels to move
              const rate = sectionProgress * parallaxDistance - 1200; // Start at -1200px, end at +600px

              $spoonBg.css({
                transform: 'translateY(' + rate + 'px)',
              });
            }

            ticking = false;
          }

          function requestTick() {
            if (!ticking) {
              requestAnimationFrame(updateParallax);
              ticking = true;
            }
          }

          $(window).on('scroll', requestTick);

          // Initial call
          updateParallax();
        }

        // Initialize state legislation mapping
        this.initStateLegislationMapping();

        // Smooth scroll to #start anchor after page load
        if (window.location.hash === '#start') {
          // Prevent default anchor scroll behavior and start at 770px
          window.scrollTo(0, 770);

          // Remove the hash from URL to prevent browser from jumping
          history.replaceState(
            null,
            null,
            window.location.pathname + window.location.search
          );

          setTimeout(function () {
            const startElement = document.getElementById('start');
            if (startElement) {
              startElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
          }, 100);
        }
      },

      // State legislation mapping
      initStateLegislationMapping: function () {
        // Get all map states (elements inside g#states)
        const mapStates = document.querySelectorAll('g#states > *');

        // Get all state content blocks
        const stateContent = document.querySelectorAll(
          '.state-tabs .state-tab-wrap'
        );

        // Loop through map states
        mapStates.forEach((mapState, index) => {
          const mapStateTitle = mapState.getAttribute('title');

          if (mapStateTitle) {
            // Loop through state content to find matching ID
            let hasLegislation = false;

            stateContent.forEach((contentBlock, contentIndex) => {
              const stateTitleDiv = contentBlock.querySelector('.state-title');
              const stateId = stateTitleDiv ? stateTitleDiv.id : null;

              if (
                stateId &&
                mapStateTitle.toLowerCase() === stateId.toLowerCase()
              ) {
                hasLegislation = true;
              }
            });

            // Add appropriate class based on whether legislation exists
            if (hasLegislation) {
              mapState.classList.add('has-legislation');
              mapState.classList.remove('no-legislation');
            } else {
              mapState.classList.add('no-legislation');
              mapState.classList.remove('has-legislation');
            }
          }
        });
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // FAQ page
    faq: {
      init: function () {
        // JavaScript to be fired on the faq page

        // FAQ Show Categories functionality (only on FAQ page)
        $('.show-categories-btn').on('click', function (e) {
          e.preventDefault();
          $(this).addClass('hide');
          $('.categories').addClass('show');
        });
      },
      finalize: function () {
        // JavaScript to be fired on the faq page, after the init JS
      },
    },
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, '_').split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, 'finalize');
        }
      );

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
